import { FacebookIcon, LinkedInIcon, InstagramIcon, TwitterIcon } from '@communityshare/ui-shared';
import React from 'react';
import logo from '@assets/images/logo.png'

const containerPx = 'px-5 md:px-8 lg:px-16 lg:max-w-screen-xl lg:mx-auto';

export default function MarketingFooter() {
  return (
    <footer className="bg-cs-navy-800 py-14" role="contentinfo">
      <div className={containerPx}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">

          {/* Logo */}
          <div className="flex items-start">
            <img
              width="150"
              height="150"
              src={logo}
              alt="CommunityShare"
              style={{ maxWidth: '100%', height: 'auto' }}
              decoding="async"
              loading="lazy"
            />
          </div>

          {/* Contact + Social */}
          <div className="flex flex-col gap-4 text-white">
            <div className="text-sm leading-relaxed">
              CommunityShare<br />
              Tucson, AZ<br />
              <a href="mailto:team@communityshare.org" className="underline hover:text-cs-orange-650">
                team@communityshare.org
              </a>
            </div>
            <div className="flex gap-3 items-center">
              <a href="https://www.facebook.com/communityshare/" rel="nofollow noreferrer noopener" target="_blank" title="Follow Us on Facebook"
                 className='btn btn-ghost'>
                <FacebookIcon className="size-6" />
              </a>
              <a href="https://www.linkedin.com/company/communityshare/" rel="nofollow noreferrer noopener" target="_blank" title="Follow Us on LinkedIn"
                 className='btn btn-ghost'>
                <LinkedInIcon className="size-6" />
              </a>
              <a href="https://www.instagram.com/community.share/" rel="nofollow noreferrer noopener" target="_blank" title="Follow Us on Instagram"
                 className='btn btn-ghost'>
                <InstagramIcon className="size-6" />
              </a>
              {/* Twitter/X placeholder */}
              <a href="https://twitter.com/community_share" rel="nofollow noreferrer noopener" target="_blank" title="Follow Us on Twitter"
                 className='btn btn-ghost'>
                <TwitterIcon className="size-6" />
              </a>
            </div>
          </div>

          {/* Candid seal + Links */}
          <div className="flex flex-col gap-4">
            <img
              loading="lazy"
              decoding="async"
              width="225"
              height="225"
              src="https://www.communityshare.org/wp-content/uploads/2026/03/candid-seal-gold-2026.png"
              alt="Candid Gold Seal of Transparency 2026"
              style={{ width: '73px', height: 'auto' }}
              srcSet="https://www.communityshare.org/wp-content/uploads/2026/03/candid-seal-gold-2026.png 225w, https://www.communityshare.org/wp-content/uploads/2026/03/candid-seal-gold-2026-150x150.png 150w, https://www.communityshare.org/wp-content/uploads/2026/03/candid-seal-gold-2026-300x300.png 300w"
              sizes="(max-width: 225px) 100vw, 225px"
            />
            <nav className="flex flex-col gap-1 text-sm text-white">
              <a href="/login" className="underline hover:text-cs-orange-650">Log in</a>
              <a href="/signup" className="underline hover:text-cs-orange-650">Sign up</a>
              <a href="http://communityshare.org/newsletter/" target="_blank" className="underline hover:text-cs-orange-650" rel="noreferrer">Signup for our newsletter</a>
            </nav>
          </div>

        </div>

        <div className="border-t border-white/20 pt-4 text-sm text-white/60">
          © Copyright 2023 CommunityShare
        </div>
      </div>
    </footer>
  );
}
